<!-- this div will be used to anchor all page content -->
<!-- in print mode it will go to the lowest of the page-->
<div class="container">
    <div class="height-2-7"></div>

    <h1 class="title" stylePreference [textColor]="textColor">{{ signaturePlaceDate }}</h1>
    <div class="height-1-4"></div>

    <div class="flex-row">
        <ng-container *ngFor="let item of signatures">
            <div class="flex-column">
                <div class="horizontal-line"></div>
                <div class="signature-text" stylePreference [textColor]="textColor">{{ item }}</div>
                <div class="height-0-1"></div>
            </div>
            <div class="width-0-22"></div>
        </ng-container>
    </div>
</div>
